import { render, staticRenderFns } from "./UsagePoliciesPage.vue?vue&type=template&id=31c30c12&"
import script from "./UsagePoliciesPage.vue?vue&type=script&lang=js&"
export * from "./UsagePoliciesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports